namespace TabAurous.ECommerce {
    export interface ReturnsManagementForm {
    }

    export class ReturnsManagementForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ReturnsManagement';
    }
}
